module.exports = __webpack_public_path__ + "static/media/value-prop-icon-3.0b986c90.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-SPRINT/value-prop-icon-3.svg
// module id = 2662
// module chunks = 0